<template>
  <div class="contact-us full-screen bg-light">
    <div class="wrapper wrapper-full-page section content">
      <div class="pt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2 text-center">
              <h2 class="text-success"><span class="ti-check-box"></span> Ο λογαριασμός σας δημιουργήθηκε</h2>
              <h3 class="">Σας έχει σταλεί στο email σας ο σύνδεσμος επιβεβαίωσης της ηλεκτρονικής σας διεύθυνσης</h3>
              <p class="text-muted mt-4">Μπορείτε να κλείσετε αυτή τη σελίδα</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
